export default (obj, notification) => {
  let data = {
    ...obj,
    path: obj.path,
    reference: obj.reference,
    file_type: obj.file_type,
    content: obj.content || obj.raw_body || "",
    extension: obj.extension,
    rename: obj.rename || null,
    folder: obj.folder || false,
    theme_id: CodeEditor.Main.themeId(),
    socket_id: window.socketId
  };
  let method = obj.method || "patch";
  if (!(data.path || data.reference || data.file_type)) {
    notification = CodeEditor.UI.notif();
    notification.error({
      message:
        "ERR:: Save aborted ! <br> path: ${data.path}<br>reference: " +
        data.reference +
        "<br>file_type: " +
        data.file_type
    });
    console.error(
      "ERR:: Save aborted ! <br> path: ${data.path}<br>reference: " +
        data.reference +
        "<br>file_type: " +
        data.file_type
    );
    return false;
  }
  let url;
  if (data.tephra) {
    url = "/api/v1/tephra_snippets/" + obj.secure_random + "/save";
  } else {
    url = "/api/v1/code_editor/" + obj.secure_random;
  }
  return $.ajax({
    url: url,
    type: method,
    headers: {
      "x-csrf-token": $("meta[name='csrf-token']").attr("content")
    },
    data: data,
    beforeSend: () => {
      if (notification) {
        notification({ message: "saving changes to: " + data.reference });
      }
    },
    success: data => {
      notification && notification.destroy();
      if (data.success === true) {
        console.log("SUCCESS!!:::", data.message);
        if (notification) {
          notification.success({ message: "done !", timeout: 2000 });
        }
      } else {
        console.error(data.message);
        if (notification) {
          notification.error({ message: data.message, timeout: 2000 });
          console.warn(obj.reference);
          console.error(data.message);
        }
      }
    },
    error: (xhr, ajaxOptions, thrownError) => {
      if (notification) {
        notification.error({ message: thrownError, timeout: 2000 });
        console.warn(obj.reference);
        console.error(thrownError);
      }
    }
  });
};
